import { useState } from "react";
import { Box, Text, Link, Collapse } from "@chakra-ui/react";
import sidebarItems from "./sidebarItems";
import {
  Routes,
  Route,
  Link as RouterLink,
  useLocation,
} from "react-router-dom";

import AboutUs from "../introduction/aboutus";
import Segmentation from "../projects/Segmentation Project/segmentation-project";
import TeamMembers from "../Team Members/teamMembers";
import News from "../News/news";
import ContactsForm from "../Contact/contact-form";
import Projects from "../projects/projects";
import Publications from "../publications/publications";
import JobOpportunity from "../job";
import DynamicPage from "../Team Members/dynamic";

import { TransitionGroup, CSSTransition } from "react-transition-group";
import "./sidebar-animation.css";
import { AddIcon, MinusIcon } from "@chakra-ui/icons";

const SidebarTitle = () => {
  return (
    <>
      <Box
        width="200px"
        height="160px"
        textAlign="justify"
        bgColor="#473198"
        px={5}
        borderRadius={2}
        marginBottom="3px"
      >
        <Text fontSize="3xl" color="white">
          Machine Learning <br /> Group
        </Text>
      </Box>
    </>
  );
};

export default function Sidebar() {
  const [selectedSubMenu, setSelectedSubMenu] = useState("");

  let location = useLocation();

  const handleClick = (title) => {
    if (title === selectedSubMenu) {
      setSelectedSubMenu("");
    } else {
      setSelectedSubMenu(title);
    }
  };

  return (
    <div>
      <Box
        display="flex"
        justifyContent="flex-start"
        alignItems="flex-start"
        mb={10}
      >
        <Box className="sidebar">
          <SidebarTitle />
          {sidebarItems.map((items) => {
            return (
              <div key={items.id}>
                <Box
                  width="200px"
                  textAlign="start"
                  cursor="pointer"
                  onClick={() => {
                    handleClick(items.title);
                  }}
                  boxShadow="lg"
                  _hover={{
                    bgColor: "#1a2963",
                    color: "white",
                  }}
                  backgroundColor={
                    location.pathname === items.url ? "#1a2963" : "white"
                  }
                  color={location.pathname === items.url ? "white" : "black"}
                  marginBottom="3px"
                  transition="background-color 0.3s ease-in"
                  display="flex"
                >
                  <Link
                    to={items.url}
                    as={RouterLink}
                    width="100%"
                    _focus={{
                      boxShadow: "none",
                    }}
                    style={{ textDecoration: "none" }}
                  >
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      paddingLeft="1rem"
                      paddingBottom="0.5rem"
                      paddingTop="0.5rem"
                      paddingRight="0.23rem"
                    >
                      <Text fontSize="xl" alignItems="flex-start">
                        {items.title}
                      </Text>
                    </Box>
                  </Link>
                  {items.subMenu && (
                    <Box alignItems="center" marginY="auto">
                      {selectedSubMenu === items.title ||
                      location.pathname ===
                        "/team-members/current-team-members" ||
                      location.pathname === "/team-members/lab-alumni" ? (
                        <MinusIcon w={5} h={3} />
                      ) : (
                        <AddIcon w={5} h={3} />
                      )}
                    </Box>
                  )}
                </Box>
                <Collapse
                  in={
                    items.title === selectedSubMenu ||
                    location.pathname ===
                      "/team-members/current-team-members" ||
                    location.pathname === "/team-members/lab-alumni"
                  }
                  transition={{ enter: { delay: 0.1 }, exit: { delay: 0.1 } }}
                >
                  {items.subMenu?.map((item) => {
                    return (
                      <Box
                        bgColor={
                          item.url === location.pathname ? "#666666" : "#e4e8e5"
                        }
                        boxShadow="md"
                        textAlign="start"
                        width="200px"
                        color={
                          item.url === location.pathname ? "white" : "black"
                        }
                        _hover={{
                          bgColor: "#666666",
                          color: "white",
                        }}
                        key={item.id}
                        onClick={(event) => {
                          event.stopPropagation();
                        }}
                        paddingLeft="1rem"
                        paddingBottom="0.5rem"
                        paddingTop="0.5rem"
                        paddingRight="0.23rem"
                        transition="background-color 0.3s ease-in"
                      >
                        <Link
                          to={item.url}
                          as={RouterLink}
                          width="100%"
                          _focus={{
                            boxShadow: "none",
                          }}
                          style={{ textDecoration: "none" }}
                        >
                          <Text>{item.title} </Text>
                        </Link>
                      </Box>
                    );
                  })}
                </Collapse>
              </div>
            );
          })}
        </Box>

        <Box width="100%">
          <TransitionGroup>
            <CSSTransition
              key={location.pathname}
              classNames="fade"
              timeout={300}
            >
              <Routes location={location.pathname}>
                <Route path="/" element={<AboutUs />} />
                <Route path="/publications/*" element={<Publications />} />

                <Route path="/team-members" element={<TeamMembers />} />
                <Route path="/team-members/:member" element={<DynamicPage />} />
                <Route path="/team-members/:member" element={<DynamicPage />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/segmentation" element={<Segmentation />} />

                <Route path="/news" element={<News />} />
                <Route path="/contacts" element={<ContactsForm />} />
                <Route path="/job" element={<JobOpportunity />} />
              </Routes>
            </CSSTransition>
          </TransitionGroup>
        </Box>
      </Box>
    </div>
  );
}
